// extracted by mini-css-extract-plugin
module.exports = {"notificator":"style_notificator__Qm2ZL","friends_image":"style_friends_image__3bty9"};